var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4439 15.1938C26.4814 8.95313 22.0033 5.8125 16.0002 5.8125C9.99393 5.8125 5.51893 8.95312 2.55643 15.1969C2.4376 15.4485 2.37598 15.7233 2.37598 16.0016C2.37598 16.2798 2.4376 16.5546 2.55643 16.8062C5.51893 23.0469 9.99706 26.1875 16.0002 26.1875C22.0064 26.1875 26.4814 23.0469 29.4439 16.8031C29.6846 16.2969 29.6846 15.7094 29.4439 15.1938ZM16.0002 23.9375C10.9596 23.9375 7.26893 21.3813 4.66581 16C7.26893 10.6188 10.9596 8.0625 16.0002 8.0625C21.0408 8.0625 24.7314 10.6188 27.3346 16C24.7346 21.3813 21.0439 23.9375 16.0002 23.9375ZM15.8752 10.5C12.8377 10.5 10.3752 12.9625 10.3752 16C10.3752 19.0375 12.8377 21.5 15.8752 21.5C18.9127 21.5 21.3752 19.0375 21.3752 16C21.3752 12.9625 18.9127 10.5 15.8752 10.5ZM15.8752 19.5C13.9408 19.5 12.3752 17.9344 12.3752 16C12.3752 14.0656 13.9408 12.5 15.8752 12.5C17.8096 12.5 19.3752 14.0656 19.3752 16C19.3752 17.9344 17.8096 19.5 15.8752 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0ac6d0d1c64f18857055b07555b0d8a6.svg";
export { ForwardRef as ReactComponent };